/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AuditLogExportRequest } from '../models/audit-log-export-request';
import { CursorPaginatedResponseAuditLogQueryDto } from '../models/cursor-paginated-response-audit-log-query-dto';
import { CursorPaginationRequest } from '../models/cursor-pagination-request';
import { ExportJobResponse } from '../models/export-job-response';
import { PaginatedResponseAuditLogQueryDto } from '../models/paginated-response-audit-log-query-dto';
import { PaginationWithFiltersRequest } from '../models/pagination-with-filters-request';


/**
 * API for browse and manage auditing.
 */
@Injectable({
  providedIn: 'root',
})
export class AuditingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listAuditLogs
   */
  static readonly ListAuditLogsPath = '/auditing/list';

  /**
   * List audit logs.
   *
   * Deprecated: use /cursor-list instead. Provides list of audit log. Audit logs are returned as unordered list.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAuditLogs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  listAuditLogs$Response(params: {

    /**
     * Pagination, sorting, and filter parameters for audit logs
     */
    body: PaginationWithFiltersRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PaginatedResponseAuditLogQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditingService.ListAuditLogsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaginatedResponseAuditLogQueryDto>;
      })
    );
  }

  /**
   * List audit logs.
   *
   * Deprecated: use /cursor-list instead. Provides list of audit log. Audit logs are returned as unordered list.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAuditLogs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  listAuditLogs(params: {

    /**
     * Pagination, sorting, and filter parameters for audit logs
     */
    body: PaginationWithFiltersRequest
  },
  context?: HttpContext

): Observable<PaginatedResponseAuditLogQueryDto> {

    return this.listAuditLogs$Response(params,context).pipe(
      map((r: StrictHttpResponse<PaginatedResponseAuditLogQueryDto>) => r.body as PaginatedResponseAuditLogQueryDto)
    );
  }

  /**
   * Path part for operation exportAuditLogs
   */
  static readonly ExportAuditLogsPath = '/auditing/export';

  /**
   * Initiate an async audit log export.
   *
   * Creates an async export job for filtered audit logs. Returns a job ID and status URL to poll. Requires auditing:read permission.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportAuditLogs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportAuditLogs$Response(params: {

    /**
     * Export filters and format
     */
    body: AuditLogExportRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExportJobResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AuditingService.ExportAuditLogsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportJobResponse>;
      })
    );
  }

  /**
   * Initiate an async audit log export.
   *
   * Creates an async export job for filtered audit logs. Returns a job ID and status URL to poll. Requires auditing:read permission.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportAuditLogs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportAuditLogs(params: {

    /**
     * Export filters and format
     */
    body: AuditLogExportRequest
  },
  context?: HttpContext

): Observable<ExportJobResponse> {

    return this.exportAuditLogs$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExportJobResponse>) => r.body as ExportJobResponse)
    );
  }

  /**
   * Path part for operation listAuditLogsCursor
   */
  static readonly ListAuditLogsCursorPath = '/auditing/cursor-list';

  /**
   * List audit logs using cursor-based pagination.
   *
   * Retrieves audit logs using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAuditLogsCursor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listAuditLogsCursor$Response(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CursorPaginatedResponseAuditLogQueryDto>> {

    const rb = new RequestBuilder(this.rootUrl, AuditingService.ListAuditLogsCursorPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CursorPaginatedResponseAuditLogQueryDto>;
      })
    );
  }

  /**
   * List audit logs using cursor-based pagination.
   *
   * Retrieves audit logs using continuation token pagination. Supports filtering and sorting. Maximum page size is 200.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAuditLogsCursor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listAuditLogsCursor(params: {

    /**
     * Cursor pagination, sorting, and filter parameters
     */
    body: CursorPaginationRequest
  },
  context?: HttpContext

): Observable<CursorPaginatedResponseAuditLogQueryDto> {

    return this.listAuditLogsCursor$Response(params,context).pipe(
      map((r: StrictHttpResponse<CursorPaginatedResponseAuditLogQueryDto>) => r.body as CursorPaginatedResponseAuditLogQueryDto)
    );
  }

  /**
   * Path part for operation getExportStatus
   */
  static readonly GetExportStatusPath = '/auditing/export/{jobId}';

  /**
   * Get export job status.
   *
   * Returns the current status of an export job. When status is COMPLETED the response contains a pre-signed download URL.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportStatus$Response(params: {
    jobId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExportJobResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AuditingService.GetExportStatusPath, 'get');
    if (params) {
      rb.path('jobId', params.jobId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportJobResponse>;
      })
    );
  }

  /**
   * Get export job status.
   *
   * Returns the current status of an export job. When status is COMPLETED the response contains a pre-signed download URL.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExportStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportStatus(params: {
    jobId: string;
  },
  context?: HttpContext

): Observable<ExportJobResponse> {

    return this.getExportStatus$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExportJobResponse>) => r.body as ExportJobResponse)
    );
  }

}
